import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useField } from 'formik';
import HandleError from '../HandleError';

export default function SelectComponent({ name, options, ...props }) {
  const [field] = useField({ name, ...props });
  return (
    <>
      <InputLabel variant="standard" htmlFor="uncontrolled-native" size="small" shrink>
        {props.label}
      </InputLabel>
      <Select
        size="small"
        {...props}
        {...field}
      >
        {options.map((x, index) => <MenuItem key={index} value={x.value}>{x.label}</MenuItem>)}
      </Select>
      <HandleError name={name} />
    </>
  );
}
